var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M7.333 5.333c0-.368.3-.666.667-.666.368 0 .667.298.667.666C8.667 5.701 8.368 6 8 6c-.368 0-.667-.299-.667-.667zm0 2c0-.368.3-.666.667-.666.368 0 .667.298.667.666v3.334c0 .368-.299.666-.667.666-.368 0-.667-.298-.667-.666V7.333zm.667 6c-2.94 0-5.333-2.392-5.333-5.333C2.667 5.06 5.06 2.667 8 2.667c2.94 0 5.334 2.392 5.334 5.333 0 2.94-2.393 5.333-5.334 5.333m0-12C4.318 1.333 1.333 4.318 1.333 8S4.319 14.667 8 14.667c3.681 0 6.667-2.985 6.667-6.667S11.68 1.333 8 1.333",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info.1e944b9d.svg";
export { ForwardRef as ReactComponent };